import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EtablissementData } from '../../../../../../../shared/utils/data/etablissments-data';
import { FormBuilder, Validators } from '@angular/forms';
import { EstablishmentService } from '../../../../../../../services/establishment.service';
import { AddressService } from '../../../../../../../services/address.service';
import { FlagService } from '../../../../../../../shared/services/flag.service';
import { AuthService } from '../../../../../../../services/auth.service';
import { FlagType } from '../../../../../../../shared/utils/enums';
import { convertToUTF8 } from '../../../../../../../shared/utils/utils.functions';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrl: './add-site.component.scss',
})
export class AddSiteComponent implements OnInit {
  addressImages: any[] = [];
  form = this.fb.group({
    name: ['', Validators.required],
    adress: ['', Validators.required],
    address: ['', Validators.required],
    pays: ['', Validators.required],
    codePostale: ['', Validators.required],
    regionCode: ['', Validators.required],
    regionName: ['', Validators.required],
    ville: ['', Validators.required],
    departmentName: ['', Validators.required],
    // isVisible: true,
    isvisible: true,
    issocial: false,
    cedex: ['', [Validators.minLength(2), Validators.maxLength(2)]],
    firstPhoto: [<string | null>null],
    secondPhoto: [<string | null>null],
    id: [<string | null>null],
    lat: [<number | null>null],
    lon: [<number | null>null],
  });
  addressList: any[] = [];
  addressLoading = false;
  addressSearched = false;
  private searchSubject = new Subject<string>();
  loading = false;
  constructor(
    public dialogRef: MatDialogRef<AddSiteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private flag: FlagService,
    private auth: AuthService,
    private addressService: AddressService
  ) {}
  ngOnInit(): void {
    if (this.data.site) {
      this.data.site.isVisible = this.data.site.isvisible;
      this.data.site.address = this.data.site.adress;
      if (this.data.site.firstPhoto == '' || !this.data.site.firstPhoto) {
        this.data.site.firstPhoto = null;
      }

      this.addressImages.push(this.data.site.firstPhoto);

      if (this.data.site.secondPhoto == '' || !this.data.site.secondPhoto) {
        this.data.site.secondPhoto = null;
      }

      this.addressImages.push(this.data.site.secondPhoto);

      this.form.patchValue(this.data.site);

    }
    // Debounce keystrokes: one request when the user pauses, not per character.
    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((query) => this.searchAddress(query));
  }

  autoCompleteOnChange(event: any) {
    this.getAddresses(event?.value);
  }
  getAddresses(wordKey: string) {
    this.form.get('adress')?.markAsTouched();
    this.form.get('regionCode')?.markAsTouched();

    // Typing invalidates any previous pick: derived fields must come from a selected
    // suggestion, so free text (e.g. "France") can never stay "valid".
    this.form.patchValue(
      {
        regionCode: '', regionName: '', codePostale: '', pays: '',
        ville: '', departmentName: '', lat: null, lon: null,
      },
      { emitEvent: false }
    );

    if (wordKey && wordKey.trim()) {
      this.searchSubject.next(wordKey.trim());
    } else {
      this.addressList = [];
      this.addressSearched = false;
    }
  }

  private searchAddress(query: string): void {
    if (!query || query.trim().length < 3) {
      this.addressList = [];
      this.addressSearched = false;
      this.addressLoading = false;
      return;
    }
    this.addressLoading = true;
    this.addressSearched = true;
    this.establishmentService.getAddress(query, 'france').subscribe({
      next: (value) => {
        // Keep only real, usable French addresses — drop country/region-only hits
        // (e.g. "France") that have no postcode and can't be a valid site address.
        this.addressList = (value || []).filter(
          (v: any) => v?.address?.country_code === 'fr' && !!v?.address?.postcode
        );
        this.addressLoading = false;
      },
      error: () => {
        this.addressList = [];
        this.addressLoading = false;
      },
    });
  }
getAdresseFormated(option: any) {
    const address = option?.address || {};
    const house_number = address?.house_number || '';
    const road = address?.road || '';
    const postcode = address?.postcode || '';
    const city = address?.city || '';
    const country = address?.country || '';
    const addressComponents = [
        house_number,
        road,
        `${postcode} ${city}`,
        country
    ];
    const filteredComponents = addressComponents.filter(component => component.trim() !== '');
    return filteredComponents.join(', ')
}
  addressSelected(item: any): void {
    const address = item?.address || {};
    this.form.get('lat')?.patchValue(+item.lat);
    this.form.get('lon')?.patchValue(+item.lon);
    this.form.get('adress')?.patchValue(this.getAdresseFormated(item));
    this.form.get('codePostale')?.patchValue(address.postcode || '');
    this.form.get('pays')?.patchValue(address.country || '');
    this.form.get('ville')?.patchValue(address.city || '');
    // Département = county (e.g. "Ain"), not the city (e.g. "Bourg-en-Bresse").
    this.form.get('departmentName')?.patchValue(address.county || address.city || '');

    // No postcode → cannot resolve a region; skip to avoid geo.api.gouv.fr/regions/undefined
    // (and the crash on res[0].codeRegion when the postcode returns nothing).
    if (!address.postcode) {
      return;
    }
    this.establishmentService.getRegionByPostalCode(address.postcode).subscribe({
      next: (res) => {
        const code = res?.[0]?.codeRegion;
        if (!code) {
          return;
        }
        this.form.get('regionCode')?.patchValue(code);
        this.establishmentService.getRegionByCode(code).subscribe({
          next: (region) => this.form.get('regionName')?.patchValue(region?.nom || ''),
          error: () => {},
        });
      },
      error: () => {},
    });
  }

  getImage(images: string[]) {
    console.log(images);

    this.form.get('firstPhoto')?.patchValue(null);
    this.form.get('secondPhoto')?.patchValue(null);

    if (images[0]) {
      this.addressImages[0] = images[0];
      this.form.get('firstPhoto')?.patchValue(images[0]);
    }
    if (images[1]) {
      this.addressImages[1] = images[1];
      this.form.get('secondPhoto')?.patchValue(images[1]);
    }
  }

  addSite() {
    this.loading = true;
    const body = this.form.value;
    delete body.address;

    this.addressService.addAddress(body, this.auth.id!).subscribe({
      next: (value) => {
        this.loading = false;
        this.dialogRef.close(true);
        this.flag.displayFlag(
          `Site ${this.data.isModify ? 'modifié' : 'ajouté'} avec succès !`,
          FlagType.success
        );
      },
      error: (err) => {},
    });
  }

  protected readonly EtablissementData = EtablissementData;
}
